export const removeAllSpaces = (value?: string | null) => {
  try {
    return value?.toString().replace(/\s/g, '') || '';
  } catch (_e) {
    return '';
  }
};

export const PrettyNumber = (a: number | string) =>
  a !== undefined && a !== null
    ? removeAllSpaces(a.toString()).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    : '';

export const formatDuration = (seconds?: string | number): string => {
  if (!seconds) return '-';

  const totalSeconds = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  if (Number.isNaN(totalSeconds) || totalSeconds < 0) return '-';

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
